import React from "react";

function getScoreClass(score) {
    if (score >= 80) return "high";
    if (score >= 65) return "medium";
    if (score >= 50) return "low";
    return "critical";
}

function ScoreBadge({ score }) {
    if (score == null) return <span className="score" style={{ opacity: 0.5 }}>{"\u2014"}</span>;
    return <span className={`score ${getScoreClass(score)}`}>{Math.round(score)}</span>;
}

export default ScoreBadge;
export { getScoreClass };
